import PreUndoData from "./PreUndoData";

export default class DeleteWaypointData extends PreUndoData {
    constructor(waypointId: string) {
        super()
        this.waypointId = waypointId // doesn't need to be cloned as it's a trivial type. Any arrays/objects should be cloned
    }
    waypointId: string
}